/* eslint-disable max-len */
import React from 'react';
import { Color } from '../../../config/Color';

type Props = {
  color?: string;
  /** Defaults to 21 */
  size?: number;
};
/**
 *
 * @param color - color of the circle containing a white tick
 * @returns
 */
export function TickColorable(props: Props): JSX.Element {
  const { color, size = 21 } = props;
  return (
    <svg
      data-test-id="tick-icon"
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="10.5" r="10.5" fill={color ?? Color.state.success} />
      <path
        d="M14.9239 7.39631C15.192 7.64369 15.192 8.07661 14.9239 8.32399L9.64409 13.6015C9.3966 13.8695 8.96349 13.8695 8.716 13.6015L6.07609 10.9627C5.80797 10.7153 5.80797 10.2824 6.07609 10.035C6.32358 9.76705 6.75669 9.76705 7.00418 10.035L9.19036 12.1996L13.9958 7.39631C14.2433 7.12831 14.6764 7.12831 14.9239 7.39631Z"
        fill="white"
      />
    </svg>
  );
}
